import { trace } from '../trace'
import { $t } from '../i18n'
import webMap from './map.web'
import '../huilianyi-js-sdk.min.js'
class Location_hly {
  async getAddress(callback) {
    trace.log('location-msg', {
      from: 'hly',
      msg: '汇联易开始定位'
    })
    console.log('汇联易开始定位')
    // 汇联易获取定位经纬度
    // hlybridge
    // mtl.getLocation({
    window.hlybridge.getLocation(
      function success(data) {
        // data = {
        //   latitude: 39.909,
        //   longitude: 116.39742
        // }
        console.log(data, '获取汇联易经纬位置信息成功')
        trace.log('location-msg', {
          from: 'hly',
          msg: '定位结束: 获取汇联易经纬位置信息成功',
          data: data
        })
        data.from = 3
        Promise.resolve(data)
          .then(webMap.geocoder)
          .then((res) => {
            if (res && res.status === 0) {
              const ret = res.result
              // const transPoint = gcoord.transform([ret.location.lng, ret.location.lat], gcoord.BD09, gcoord.GCJ02)
              let paramsMsg = {
                province: ret.addressComponent.province,
                city: ret.addressComponent.city || ret.addressComponent.district,
                district: ret.addressComponent.district,
                address: ret.formatted_address,
                lon: data.longitude,
                lat: data.latitude,
                code: '0'
              }
              console.log(paramsMsg, '获取汇联易城市位置信息成功')
              trace.log('location-msg', {
                from: 'hly',
                msg: '定位成功: 获取汇联易城市位置信息成功',
                data: paramsMsg
              })
              callback(paramsMsg)
            } else {
              console.log(data, '获取汇联易经纬位置信息城市翻译API失败')
              trace.log('location-msg', {
                from: 'hly',
                msg: '定位失败: getLocation',
                data: { code: -1, msg: '获取汇联易经纬位置信息城市翻译API失败' }
              })
              callback({ code: -1, msg: '获取汇联易经纬位置信息城市翻译API失败' })
            }
          })
      },
      function fail(err) {
        // success(err) {
        console.log('汇联易mtl定位失败,错误信息 --- ', err)
        let message = err.message // 错误信息
        trace.log('location-msg', {
          from: 'hly',
          msg: `汇联易mtl定位失败`,
          data: `失败原因: ${message}`
        })
        if (window.$tool?.webMap) {
          console.log('汇联易定位失败-转用h5定位兜底: getAddress')
          trace.log('location-msg', {
            from: 'hly',
            msg: '汇联易定位失败-转用h5定位兜底: getAddress'
          })
          window.$tool.webMap.getAddress(callback)
        } else {
          console.log('定位失败-h5兜底失败 $tool.webMap 尚未加载: getAddress')
          trace.log('location-msg', {
            from: 'hly',
            msg: '定位失败-h5兜底失败 $tool.webMap 尚未加载: getAddress'
          })
          callback({
            code: -1,
            msg: $t('toolwebmap-shang-wei-jia-zai')
          })
        }
      }
    )
  }
}
export default Location_hly
